import AppRoutes from "./routes";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalLoader from "./utils/globalLoader";
import CookieConsent from "./utils/cookieConsent";

const theme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
  },
  palette: {
    mode: "light",
  },
});

function App() {
  // useSessionHandler(); // Tracks and removes token on full browser close
  return (
    <ThemeProvider theme={theme}>
      <GlobalLoader />
      <CssBaseline />
      <AppRoutes />
      <CookieConsent />
    </ThemeProvider>
  );
}

export default App;
